export class SaasSeatCharge {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "seats",
            "baseName": "seats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "pricePerSeat",
            "baseName": "pricePerSeat",
            "type": "number",
            "format": ""
        },
        {
            "name": "cost",
            "baseName": "cost",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasSeatCharge.attributeTypeMap;
    }
    constructor() {
    }
}
